/**
 * Truncates a string to a specified length, optionally appending a custom ending.
 *
 * If the string exceeds the specified limit, it prioritizes truncating at the last space
 * before the limit (if possible) for better readability, and the ending will be appended.
 * If no space is found, the string is cut at the limit minus the ending length and the ending is appended.
 *
 * @param str - The string to truncate.
 * @param limit - The maximum allowed length of the resulting string, including the ending.
 * @param ending - The string to append to the end of the truncated string. Defaults to '...'.
 * @returns The truncated string with the ending appended if truncation occurred.
 */
export default function stringTruncate(str: string, limit: number, ending: string = "..."): string {
  if (str.length <= limit) return str;

  if (limit < ending.length) return ending;

  const lastSpaceIndex = str.lastIndexOf(" ", limit - ending.length);

  if (lastSpaceIndex !== -1) {
    return str.slice(0, lastSpaceIndex) + ending;
  } else {
    return str.slice(0, limit - ending.length) + ending;
  }
}
